import React from 'react';
import styles from '../styles/WelcomeMessage.module.css';
import modalStyles from '../styles/modal.module.css';
import Button from './Button';
import FaIcon from './FaIcon';

const WelcomeMessage = ({ onClose }) => {
  return (
    <div className={modalStyles.modalContent}>
      <div className={styles.welcomeContainer}>
        <div className={styles.welcomeSection}>
          <p className={styles.welcomeText}>
            Un benvenuto speciale agli iscritti di <b>Teacher Stefano</b>! 
            Siamo felici che tu sia qui grazie alla sua newsletter. 
            Abbiamo creato questi giochini di parole per aiutarti a migliorare il tuo italiano 
            in modo divertente e coinvolgente.
          </p>
          
          <p className={styles.welcomeText}>
            Giocare ogni giorno ti aiuterà a imparare nuove parole 
            e scoprire curiosità sulla lingua e sulla cultura italiana. 
            È un modo semplice e piacevole per tenere il tuo italiano sempre attivo!
          </p>

          <p className={styles.welcomeText}>
            Ti consigliamo di iniziare con <b>Collegamenti</b>, è un ottimo modo per 
            scoprire i nostri giochi! Ricordati pure, puoi sempre rileggere le istruzioni 
            cliccando sull'icona <FaIcon className="fa fa-question-circle" /> o chiedere un aiuto extra con l'icona <FaIcon className="fa fa-medkit" />. Buon divertimento!
          </p>
          
        </div>
        
        <div className={styles.ctaSection}>
          <Button primary onClick={onClose}>
            Inizia a giocare!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage; 